export default __webpack_public_path__ + "static/media/twitter.eefebeb7.svg";